<template>
  <div class="components-container" style="display: flex">
    <!-- <split-pane split="vertical" @resize="resize" :default-percent="16" :dividerSize="1"> -->
    <!-- <template slot="paneL"> -->
    <div class="left-container left"  id="pdftree">
      <el-aside style="width: 100%">
        <el-row style="text-align: left">
          <span style="font-size: 20px; font-weight: bold">任务回复</span>
        </el-row>
        <el-row>
          <hr
            size="1"
            style="
              color: #ff9999;
              border-style: double;
              color: #ccc;
              margin-top: 10px;
            "
          />
        </el-row>

        <el-tabs v-model="activeName" type="card" v-show="!opinion_show">
          <el-tab-pane name="tuzhi">
            <span slot="label">图纸信息</span>
            <div style="height: 700px; overflow: auto">
              <el-tree
                :data="tree.data"
                node-key="id"
                ref="tree"
                :loading="tree.loading"
                show-checkbox
                @node-click="selectTreeID"
                highlight-current
                :props="defaultProps"
              >
                <span slot-scope="scope" :title="scope.data.label">
                  <!--图纸是否有意见-->
                  <i
                    v-if="scope.data.drawingOpinion == '1'"
                    class="el-icon-tickets"
                    style="color: #409eff"
                  ></i>
                  <span>{{ scope.data.label }}</span>
                  <!-- <i class="el-icon-edit" style="color: #409eff;"
                          v-if="scope.data.type == 'archive'&&!scope.data.readOnly"></i>
                        <i
                          :class="[scope.data.type != 'drawing' ? 'el-icon-tem-wenjianjia' : 'el-icon-tem-wenben']"></i>{{scope.data.name}}{{scope.data.numbertext}}
                        <span
                          v-if="scope.data.type == 'archive'"
                          :class="[scope.data.checkOn > 0 ? 'font-green' : scope.data.status == '已退回' ? 'font-red' : '']">
                          ({{scope.data.status}}){{scope.data.archiveStatus==2?'('+'缺图纸'+')':''}}
                      </span>-->
                </span>
              </el-tree>
            </div>
          </el-tab-pane>
          <el-tab-pane name="wenti" v-if="problem_show">
            <span slot="label">审查意见</span>
            <el-row style="overflow: auto; max-height: 800px">
              <div style="width: 400px">
                <el-table
                  :data="self_work"
                  @cell-dblclick="pdfset"
                  style="width: 400px"
                >
                  <el-table-column
                    label="审查问题"
                    prop="problemDescription"
                    align="center"
                    style="width: 400px"
                  ></el-table-column>
                  <el-table-column label="违反条目" prop="gbdescription" align="center"></el-table-column>
                        <el-table-column label="问题类别" prop="problemType" align="center" width="100"></el-table-column>
                        <el-table-column
                          label="问题子专业"
                          prop="problemSubMajor"
                          align="center"
                          width="100"
                      ></el-table-column>
                </el-table>
              </div>
            </el-row>
          </el-tab-pane>
          <el-tab-pane name="text" v-if="body_work.length && !problem_show">
            <span slot="label">审查意见</span>
            <el-row style="overflow: auto; max-height: 800px">
              <div style="width: 400px">
                <el-table
                  :data="body_work"
                  @cell-dblclick="pdfword"
                  style="width: 400px"
                >
                  <el-table-column
                    label="审查问题"
                    prop="problemDescription"
                    align="center"
                    style="width: 400px"
                  ></el-table-column>
                  <el-table-column label="违反条目" prop="gbdescription" align="center"></el-table-column>
                    <el-table-column label="问题类别" prop="problemType" align="center" width="100"></el-table-column>
                    <el-table-column
                      label="问题子专业"
                      prop="problemSubMajor"
                      align="center"
                      width="100"
                  ></el-table-column>
                </el-table>
              </div>
            </el-row>
          </el-tab-pane>
        </el-tabs>
        <el-card v-if="opinion_show">
          <el-form
            ref="opinionForm"
            style="text-align: left"
            label-width="110px"
            :model="opinionForm"
            size="small"
          >
            <el-form-item prop="problemType" label="违反类别">
              <el-select
                v-model="opinionForm.problemType"
                placeholder="请选择"
                style="width: 100%"
                :disabled="true"
              >
                <el-option
                  v-for="item in problemTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item prop="problemSubMajor" label="强标强条类型">
              <el-select
                v-model="opinionForm.problemSubMajor"
                placeholder="请选择"
                style="width: 100%"
                :disabled="true"
              >
                <el-option
                  v-for="item in problemSubMajorOptions"
                  :key="item.id"
                  :label="item.subProfession"
                  :value="item.subProfession"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              v-if="Number(opinionForm.isHiddenDanger)"
              prop="dangerType"
              label="严重程度"
            >
              <el-select
                v-model="opinionForm.dangerType"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="item in dangerTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              prop="hiddenDangerReason"
              label="安全说明"
              v-if="
                Number(opinionForm.isHiddenDanger) &&
                opinionForm.dangerType == '严重'
              "
            >
              <el-input
                type="textarea"
                placeholder="请输入内容"
                v-model="opinionForm.hiddenDangerReason"
              ></el-input>
            </el-form-item>
            <el-form-item prop="gbdescription" label="违反条目">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 2 }"
                resize="none"
                placeholder="请输入内容"
                v-model="opinionForm.gbdescription"
              ></el-input>
              <span>{{ opinionForm.gbcaption }}</span>
            </el-form-item>

            <el-form-item prop="problemDescription" label="问题描述">
              <el-input
                type="textarea"
                resize="none"
                :autosize="{ minRows: 3, maxRows: 3 }"
                placeholder="请输入内容"
                v-model="opinionForm.problemDescription"
              ></el-input>
            </el-form-item>
          </el-form>

          <el-row :gutter="20" style="text-align: center">
            <el-col :span="6">
              <el-button
                type="primary"
                size="mini"
                @click="opinion_show = false"
                >返回目录</el-button
              >
            </el-col>
          </el-row>
        </el-card>
      </el-aside>
    </div>





    <div id="dragbar" class="resize" ref="resize" style="background: rgb(64, 158, 255);margin-top: 60px;width: 5px;"></div>





    <div class="bottom-container" style="width: 100%" id="pdfplugin">
      <!-- <el-main style="margin-left:2px"> -->
      <el-row style="text-align: center">
        <el-col :span="4">
          <el-upload
            class="upload-demo"
            :before-upload="beforeUpload"
            :on-error="uploadFail"
            :on-success="uploadSuccess"
            ref="upload"
            multiple
            :disabled="status.drawingUpload"
            :action="url.upload"
          >
            <el-button
              slot="trigger"
              :disabled="status.drawingUpload"
              type="primary"
              size="small"
              >替换补充图纸</el-button
            >
          </el-upload>
        </el-col>
        <el-col :span="4">
          <el-button @click="drawing_delete" type="primary" size="small"
            >删除图纸</el-button
          >
        </el-col>
        <!-- <el-col :span="4">
                  <el-button @click="drawing_signature" type="primary" size="small" :disabled="status.drawing">图纸签章</el-button>
              </el-col>-->
        <el-col :span="4">
          <el-button
            @click="reply_upload"
            type="primary"
            size="small"
            :disabled="status.drawingUpload" 
            >上传回复单</el-button
          >
        </el-col>
        <el-col :span="4">
          <el-button
            @click="reply_finish"
            type="primary"
            size="small"
            :disabled="status.reply || nodeData.checkStatus === 1"
            >回复完成</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <hr
          size="1"
          style="
            color: #ff9999;
            border-style: double;
            color: #ccc;
            margin-top: 20px;
          "
        />
      </el-row>
      <el-row style="height: 100%">
        <!--<iframe :src="iframe_url" frameborder="0" style="width: 100%;height: 900px;" ></iframe>-->
        <div
          class="main"
          style="border: 1px solid #000; width: 100%; height: 100%"
        >
          <div class="pdf-info"></div>
          <div
            class="pdf-wrapper"
            style="border: 1px solid #000; width: 100%; height: 100%"
          >
            <div
              id="pdf-container"
              class="pdf-container"
              style="border: 1px solid #000; width: 100%; height: 100%"
            ></div>
          </div>
        </div>
      </el-row>

      <!-- </el-main> -->
    </div>
    <!-- </template> -->
    <!-- </split-pane> -->
    <!-- 弹窗-->
    <el-dialog :title="table.title" :visible.sync="table.visible" size="small">
      <el-row style="text-align: right">
        <el-upload
          class="upload-demo"
          ref="reply_upload"
          accept=".PDF"
          :on-success="file_upload"
          :on-error="upload_error"
          :action="url.uploadFile"
          :auto-upload="true"
        >
          <el-button type="primary" size="small">上传回复单</el-button>
        </el-upload>
      </el-row>
      <el-table
        :data="table.data"
        v-loading="table.loading"
        stripe
        style="width: 100%; text-align: left"
      >
        <el-table-column type="index" label="序号" width="70"></el-table-column>
        <el-table-column prop="name" label="回复单名称"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <a :href="download_template(scope.row.uploadPath)" target="_blank" style="color:#409EFF;text-decoration: none;">查看</a>
            <el-button
              @click="reply_delete(table.data, scope.$index)"
              type="text"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {
  PDFPlugin,
} from "../../styles/js/pdf.plugin";
import {
  PROBLEM_TYPE_OPTIONS,
  PROBLEM_STRONG_OPTIONS,
  PROBLEM_SUBMAJOR_OPTIONS,
  DANGER_TYPE_OPTIONS,
  PROFESSIONALCON1,
  PROFESSIONALCON2,
  PROFESSIONALCON3,
  PROFESSIONALCON4,
  PROFESSIONALCON5,
} from "./constants.js";
export default {
  name: "SplitpaneDemo",
  data() {
    return {
      plugin: {},
      dblclick_ad: false,
      problem_show: false,
      activeName: "tuzhi",
      problemMap: {},
      opinion_show: false,
      PDFReader_show: false,
      opinionForm: {},
      self_work: [],
      body_work: [],
      pdfword_re: "",
      url: {
        opinions: "/design/opinions",
        upload: "/design/att/uploadatt",
        uploadFile: "/design/att/upload",
        drawing: "/design/drawing",
        getProblems: "/design/problem/no-paging",
        problem: "/design/problem/query",
      },
      nodeData: {},
      tree: {
        data: [],
        loading: true,
      },
      table: {
        title: "意见回复",
        visible: false,
        pagination: {
          currentPage: 1,
          pageSize: 10,
          total: 0,
        },
        loading: true,
        data: [],
      },
      dialog: {
        title: "上传意见回复",
        visible: false,
        data: {
          name: "",
          path: "",
        },
        rules: {},
      },
      problemTypeOptions: PROBLEM_TYPE_OPTIONS,

      status: {
        drawingUpload: true,
        drawing: true,
        reply: true,
      },
      taskID: "",
      fileCount: 0,
      defaultProps: {
        children: "children",
        label: "label",
      },
      iframe_url: "",
      IsSucceed: false,
      plugin: null,
    };
  },
  created() {
    this.taskID = this.PDFURL().query.id;
    document.cookie = `JSESSIONID=${this.PDFURL().query.session};path=/design;`;
    this.query();
    this.query1();
  },
  mounted() {
    this.plugin = new PDFPlugin("pdf-container");
  },
  methods: {
    resize() {
      console.log("resize");
    },
   

    query1() {
      // 请求树形图数据
      this.$http
        .get("/design/opinions/reply-list/" + this.$route.query.id)
        .then(
          (res) => {
            if (res.ok) {
              this.taskid = res.data.result.id;
              // this.taskCensorCircs = res.data.result.task.censorCircs;
              
              res.data.result.children.forEach((item) => {
                let n = 0;
                let fa = (data) => {
                  let num = data.filter((ta) => {
                    if (ta.children) {
                      fa(ta.children);
                    }
                    if (ta.trash) {
                      n = n - ta.children.length;
                    }
                    return (
                      ta.type &&
                      ta.type == "drawing" &&
                      (ta.status || ta.status === 0)
                    );
                  }).length;
                  n += num;
                };
                fa(item.children);
                item.numbertext = `(共${n}张)`;
              });
              res.data.result.reply = true;
              let datas = [];
              datas.push(res.data.result);
              // this.censorcirlStatus = res.data.result.task.censorCircs;
              // if (res.data.result.task.censorCircs != 4) {
              //   this.recheck = false;
              // }
              let fa = (it) => {
                it.forEach((item) => {
                  item.node_key = Math.random().toString(36).substr(2);
                  if (item.children) {
                    fa(item.children);
                  }
                });
              };
              fa(datas);
              this.tree.data = datas;
            } else {
              alert(JSON.stringify(data));
              this.$message.error("查询失败，请联系管理员");
            }
          },
          (error) => {
            alert(JSON.stringify(error));
            this.$message.error("查询失败，请联系管理员");
          }
        );
    },
    // 查询图纸意见  发送给插件 对接信息
    queryzuobiao(data) {
      // 查询单张图纸的id，返回改图纸的意见，发送给插件，并渲染页面
      this.body_work = []
      this.problem_show = false
      this.$http
        .get("/design/problem/no-paging?drawingNumber=" + data.id)
        .then((resp) => {
          if (resp.data.result) {
            this.self_work = resp.data.result;
            let arrb = [];
            this.self_work.forEach((item) => {
              let data = {};
              data.rcid = item.id;
              data.flags = item.annotXml;
              arrb.push(data);
            });
            let cache = "";
            resp.data.result.length > 0 ?  this.problem_show = true : this.problem_show = false
            // this.problem_show = true
            if(data.readOnly==true){
              cache = true
            }else{
              cache = false
            }
            this.plugin.open({
              url: "http://180.103.123.58:8088//upload" + data.url,
              status: -1,
              expert: false,
              cache: false, //不缓存
              listener: this.drawing_listener,
              data: arrb,
            });
          }
        });
    },

    //树
    selectTreeID(data) {
      if (this.dblclick_ad) {
        return false;
      }
      this.dblclick_ad = true;
      this.url.upload = "/design/att/uploadatt";
      this.status.drawingUpload = true;
      this.status.drawing = true;
      this.status.reply = true;
      this.nodeData = data;
      this.IsSucceed = false;
      if (data.url) {
        this.IsSucceed = true;
        // this.problem_show = true;
        this.status.drawing = data.task ? false : true;
        this.opinionForm.drawingNumber = data.id;
        this.currpdf_name = data.name;
        this.queryzuobiao(data);
        // this.getproblem( // 20200924 注释原因  点击图纸不应该查询单体意见
        //   {
        //     taskId: this.$route.query.id,
        //     profession: data.profession,
        //     projectID: data.project,
        //   },
        //   data
        // );
        // this.PDFOpenFile(data.project);
        if (data.checkStatus === 0) this.status.drawingUpload = false;
      } else if (data.task) {
        this.PDFOpenFile(data);
        this.PDFOpenFile1(data);
        // this.getproblem({
        //   taskId: this.taskID,
        //   profession: data,
        // });
        this.status.drawingUpload = false;
        // this.problem_show = true;
        this.PDFReader_show = true;
        this.url.upload += encodeURI(
          "?project=" +
            data.project +
            "&task=" +
            data.task +
            "&profession=" +
            data.profession +
            "&examine=" +
            data.id
        );
        this.status.reply = false;
      } else if (data.id) {
        // this.PDFOpenFile(data.project);
        // this.getproblem({
        //   taskId: this.taskID,
        //   profession: data.label,
        // });
        this.status.reply = false;
      }
      setTimeout(() => {
        this.dblclick_ad = false;
      }, 400);
    },
    
    // 点击树节点
    getproblem(data, treeData) {
      data.profession = data.profession.split("(")[0];
      let json = [];
      this.body_work = [];
      // this.problem_show = false;
      // this.self_work = []
      this.$http
        .get(this.url.problem, {
          params: data,
        })
        // .get('/design/problem/list?drawingNumber=' + treeData.id)
        .then((res) => {
          this.body_work = res.body.result;
          this.problem_show = false;
        });
      // this.body_work = json;
    },
    // 获取单体意见
    PDFOpenFile(data) {
      this.$http
        .get(
          "/design/problem/query?taskId=" +
            this.$route.query.id +
            "&profession=" +
            data.profession
        )
        .then((res) => {
          this.self_work = res.data.result;
          this.problem_show = true;
        });
    }, // 单体图纸
    PDFOpenFile1(id) {
      // this.$http.get("/draw/opinions/pdfSign/" + id).then((res) => {
      //   this.plugin.open({
      //     url: res.bodyText,
      //     status: 1,
      //     expert: true,
      //     cache: false, //不缓存
      //   });
      // });
    },
    pdfword(data) {
      let statusnum = data.drawing.drawingStatus;
      let rcid = data.id;
      if (
        data.annotXml != null &&
        data.annotXml != "" &&
        data.annotXml != "[]"
      ) {
        this.plugin.open({
          url: "http://180.103.123.58:8088//upload" + data.drawing.blueprintPath,
          status: statusnum,
          expert: data.readOnly,
          cache: false,
          listener: this.drawing_listener,
          data: [{ rcid: rcid, flags: data.annotXml }],
        });
        this.plugin.curEditorWindow.findFlags(rcid);
        // this.openSuccess();
        this.opinion_show = true;
        this.opinionForm = data;
      } else {
        this.opinionForm = data;
        this.opinion_show = true;
      }
    },
    pdfset(data) {
      if (
        data.annotXml != null &&
        data.annotXml != "" &&
        data.annotXml != "[]"
      ) {
        this.plugin.open({
          url: "http://180.103.123.58:8088//upload" + data.drawing.blueprintPath,
          status: -1,
          expert: true,
          cache: false,
          listener: this.drawing_listener,
          data: [{ rcid: data.id, flags: data.annotXml }],
        });
        this.opinion_show = true;
        this.opinionForm = data;
      } else {
        this.opinionForm = data;
        this.opinion_show = true;
      }
    },
    onPDF_openFile(IsSucceed, FilePath, PDFID, Extend) {
      // pdf 文件打开的回调
      if (IsSucceed && this.IsSucceed) {
        for (let name in this.problemMap) {
          this.pr.DeleteAnnot(name, "");
        }
        this.getProblems(this.opinionForm.drawingNumber).then(
          (resp) => {
            if (resp.status == 200) {
              // 初始化
              this.problemMap = {};
              this.xmlMap = {};
              let regx = /<GUID>(.*?)<\/GUID>/g;
              let xml_init = "";
              resp.body.result.forEach((item) => {
                let _this = this;
                xml_init += item.annotXml;
                // let guid = ''
                if (item.annotXml) {
                  item.annotXml.replace(regx, function (m, p) {
                    _this.problemMap[p] = item;
                    _this.xmlMap[p] = item.annotXml;
                    // guid = p
                    return m;
                  });
                  item.projectId = item.id;
                  // this.problemMap[guid] = item
                  // this.xmlMap[guid] = item.annotXml
                }
              });
              xml_init = `<root>${xml_init}</root>`;
              this.pr.AddAnnot(3, xml_init, "");
              if (this.pdfword_re) {
                this.pr.SetReadZoom(100);
                this.pr.GotoAnnot(this.pdfword_re, "");
                this.pdfword_re = "";
              }
            } else {
              console.log("getProblems fail");
            }
          },
          (err) => {
            console.log(err);
          }
        );
      }
    },
    onPDF_selectAnnot(ZSGuid, ZSType, Extend) {
      // pdf 注释选择后的回调
      this.opinion_show = true;
      this.activeGUID = ZSGuid;
      let problem = this.problemMap[ZSGuid];
      if (problem) this.opinionForm = problem;
    },
    onPDF_addAnnot(ZSGuid, ZSType, Extend) {
      //                 /////
    },
    PDF_getCurrAnnot() {
      // 获取当前页面的所有标注
      let annotXml = this.pr.GetAllAnnotInfo("");
      const reg = /(<annot>(?:.*?)<\/annot>)/g;
      const regx = /<GUID>(.*?)<\/GUID>/g;
      annotXml = annotXml.replace(/\n|\t|\r/gm, "");
      let annotXmlMap = {};
      annotXml.replace(reg, function (match, p1) {
        p1.replace(regx, function (m, p) {
          annotXmlMap[`${p}`] = p1;
          return m;
        });
        return match;
      });
      return annotXmlMap;
    },
    PDFURL() {
      const URL = window.location.href;
      const arr = URL.split("?");
      const hash = arr[0];
      let query = arr[1] ? arr[1] : "";
      const qus = {};
      if (query) {
        query = query.split("&");
        for (let n = 0; n < query.length; n++) {
          let hs = query[n].split("=");
          qus[hs[0]] = hs[1] ? hs[1] : "";
        }
      }
      return {
        query: qus,
        url: hash,
      };
    },
    getProblems(drawingNumber) {
      return this.$http.get(`${this.url.getProblems}`, {
        params: {
          drawingNumber,
        },
      });
    },
    //删除回复单
    reply_delete(rows, index) {
      if (confirm("此操作将永久删除该记录, 是否继续?")) {
        this.$http
          .delete(this.url.opinions + "/reply-delete/" + rows[index].id)
          .then(
            function (response) {
              if (response.body.status === 200) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                rows.splice(index, 1);
              }
            },
            function (response) {
              this.$message({
                type: "error",
                message: "删除失败",
              });
            }
          );
      }
    },
    //回复完成
    reply_finish() {
      if (confirm("回复完成, 是否继续?")) {
        this.$http
          .post(
            this.url.opinions + "/reply-complete/" + this.PDFURL().query.id,
            this.nodeData.label.replace(/\((.*?\))/, "")
          )
          .then(
            (res) => {
              if (res.body.status === 200) {
                this.query();
                this.status.reply = true;
                this.$message.success("回复已完成");
              } else {
                this.$message.error(res.body.message);
              }
            },
            (error) => {
              this.$message.error("回复失败");
            }
          );
      }
    },
    //删除图纸
    drawing_delete() {
      var treeNodes = this.$refs.tree.getCheckedNodes();
      var deleteID = [];
      var deleteName = [];
      treeNodes.forEach((data) => {
        if (data.url) {
          deleteID.push(data.mainID);
          deleteName.push(data.label);
        }
      });
      if (deleteID.length <= 0) {
        this.$message.warning("请选择需要删除的图纸");
        return;
      }
      if (
        confirm(
          "此操作将永久删除图纸  （" + deleteName.join(" || ") + "）, 是否继续?"
        )
      ) {
        this.$http.post(this.url.drawing + "/deleteall", deleteID).then(
          (res) => {
            if (res.body.status === 200) {
              this.query();
              this.$message.success("删除成功");
            } else {
              this.$message.error("删除失败");
            }
          },
          (error) => {
            this.$message.error("删除失败");
          }
        );
      }
    },
    //图纸替换
    drawing_replace() {},
    //图纸签章
    drawing_signature() {},
    //回复上传
    reply_upload() {
      this.table.visible = true;
      this.query_reply();
    },
    reply_upload_show() {
      this.dialog.visible = true;
    },
    closeDialog() {
      this.$refs.reply_upload.clearFiles();
      this.$refs.refForm.resetFields();
      this.dialog.visible = false;
    },
    download_template(uploadUrl) {
      const link = document.createElement("a");
      link.href = uploadUrl;
      link.setAttribute("download");
      document.body.appendChild(link);
      link.click();
    },
    upload_error(err) {
      console.log(err);
    },
    file_upload() {
      var list = this.$refs.reply_upload.uploadFiles;
      let data = {};
      data.path = list[0].response.filePath;
      data.name = list[0].name;
      //post请求
      this.$http
        .post(this.url.opinions + "/upload-reply/" + this.nodeData.id, data)
        .then(
          (res) => {
            this.$refs.reply_upload.clearFiles();
            if (res.body.status === 200) {
              this.$message.success("添加成功");
              this.query_reply();
            } else {
              this.$message.error("添加失败，请联系管理员");
            }
          },
          (error) => {
            this.$message.error("查询失败，请联系管理员");
          }
        );
    },
    query_reply() {
      this.table.loading = true;
      this.$http
        .get(this.url.opinions + "/reply-list/" + this.nodeData.id)
        .then((res) => {
          this.table.loading = false;
          if (res.body.status === 200) {
            this.table.data = res.data.result;
          } else {
            this.$message.error("查询失败，请联系管理员");
          }
        });
    },


    drawing_listener(event, obj) {
      switch (event) {
        case "newReviewComments":
          this.newReviewComments();
          break;
        case "removeFlags":
          this.removeFlags(obj);
          break;
          // 全屏
        case "fullscreen":
          this.fullscreen();
          break;
        case "openReviewComments":
          this.openReviewComments(obj);
          break;
        case "openSuccess":
          this.openSuccess();
          break;
      }
    },
    newReviewComments() {
      this.opinion_show = true;
      this.resetForm();
    },
    fullscreen() {
      let editor = document.getElementById("pdf-container");
      if (editor.requestFullscreen) {
        editor.requestFullscreen();
      } else if (editor.mozRequestFullScreen) {
        editor.mozRequestFullScreen();
      } else if (editor.webkitRequestFullscreen) {
        editor.webkitRequestFullscreen();
      } else if (editor.msRequestFullscreen) {
        editor.msRequestFullscreen();
      }
    },
    openReviewComments(obj) {
      let url = "/design/problem/";
      this.$http.get(url + obj.rcid).then((res) => {
        this.opinion_show = true;
        this.opinionForm = res.data.result;
      });
    },
    dawr_number(data) {
      let n = 0;
      data.children.forEach((item) => {
        if (item.task && item.project) {
          n += item.children.length;
        }
        if (item.children.filter((it) => it.trash).length) {
          n = n - 1;
        }
      });
      return n;
    },
    query() {
      this.tree.loading = true;
      this.fileCount = 0;
      this.$http.get(this.url.opinions + "/reply/" + this.taskID).then(
        (res) => {
          this.tree.loading = false;
          if (res.body.status === 200) {
            res.data.result.forEach((item) => {
              let n = 0;
              let fa = (data) => {
                let num = data.filter((ta) => {
                  if (ta.children) {
                    fa(ta.children);
                  }
                  return ta.url && ta.label;
                }).length;
                n += num;
              };
              fa(item.children);
              item.label = item.label + `(共${n}张)`;
            });
            this.tree.data = res.data.result;
          } else {
            this.$message.error("查询失败，请联系管理员");
          }
        },
        (error) => {
          this.$message.error("查询失败，请联系管理员");
        }
      );
    },
    beforeUpload(file) {},
    //上传错误
    uploadFail(err, file, fileList) {
      this.url.upload = "/design/att/uploadupdateatt";
    },
    //上传图纸成功
   uploadSuccess(response, file, fileList) {
      this.url.upload = "/design/att/uploadupdateatt";
      this.fileCount++;

      if (this.fileCount == fileList.length) {
        this.query();
        this.$refs["upload"].clearFiles();
      }
    },
    download_template(uploadUrl) {
    		return encodeURI('/upload'+uploadUrl)
    	},
  },
};
</script>

<style  scoped>
.components-container {
  position: relative;
  height: 100vh;
}

.left-container {
  height: 100%;
}
/* /deep/ .left-container .el-tabs__content{
  width: 450px;
} */

.right-container {
  height: 200px;
}

.top-container {
  width: 100%;
  height: 100%;
}
html,
body,
#app {
  height: 100%;
}
#dragbar :hover {
  cursor: move;
}
.resize{
}

  #dragbar {
    cursor: pointer;
  }
  #dragbar :hover {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/views/login/pdfIndexReply.vue